import { render, staticRenderFns } from "./AppView.vue?vue&type=template&id=d985d9f4&scoped=true&"
import script from "./AppView.vue?vue&type=script&lang=js&"
export * from "./AppView.vue?vue&type=script&lang=js&"
import style0 from "./AppView.vue?vue&type=style&index=0&id=d985d9f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d985d9f4",
  null
  
)

export default component.exports